import { render, staticRenderFns } from "./SwisetRatioStats.vue?vue&type=template&id=2b508587&scoped=true"
import script from "./SwisetRatioStats.vue?vue&type=script&lang=js"
export * from "./SwisetRatioStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b508587",
  null
  
)

export default component.exports